(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('.footer-menu--collapsible .footer-menu__details').forEach(function (d) {
        if (mq.matches) {
          d.setAttribute('open', '');
        }
      });
    }
    sync();
    mq.addEventListener('change', sync);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    // Progressive reveal: when any field inside the block first receives focus,
  // latch a `--expanded` class on the block so styling can slide the remaining
  // fields in (and keep them open). Delegated focusin works for the
  // late-rendered Klaviyo embed and only ever adds the class (never removes it).
  document.addEventListener('focusin', function (event) {
    var block = event.target.closest('.footer-newsletter');
    if (block) block.classList.add('footer-newsletter--expanded');
  });
  } catch(e) { console.error(e); }
})();

})();
